import { useContext, useMemo, useState } from 'react'

import { useSelector } from 'react-redux'
import { TreeSelect } from 'antd'

import SearchCheckbox from '../../../../Components/antd/Selects/SearchCheckbox'
import InstitutionSchoolsList from '../../Quotas/SchoolQuotasView/InstitutionSchoolsList'
import InstitutionSectionsList from '../../Quotas/SchoolQuotasView/InstitutionSectionsList'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'
import { calc, pc, px } from '../../../../utils/cssHelper'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { getIdOrNull } from '../../../../utils'

const PADDING = 12

const Prefixes = Object.freeze({
  DEPARTMENT: 'D_',
  SECTOR: 'S_'
})

const Settings = ({ isHostpitalDepartmentViewToggled, schools, selectedSections, selectedSectors, onSelectEntity, onSelectSchools, onSelectSections }) => {
  const { sectors, loading } = useContext(InstitutionContext)

  const t = useSelector(selectTranslate)

  const [selected, setSelected] = useState([])

  const sectorsByHospitalDepartments = useMemo(() => Object.values(sectors.reduce((acc, sector) => {
    const departmentId = getIdOrNull(sector.hospitalDepartment)

    if (departmentId !== null) {
      if (!acc.map[departmentId]) {
        acc.map[departmentId] = { ...sector.hospitalDepartment, sectors: [] }
      }

      acc.map[departmentId].sectors.push(sector)
    }

    return acc
  }, { map: {} }).map), [sectors])

  const handleSelect = truc => {
    const filtered = truc.filter(t => !t.startsWith(Prefixes.DEPARTMENT))
    setSelected(filtered)

    onSelectEntity(filtered
      .map(f => getIdOrNull(f.split(Prefixes.SECTOR)[1]))
      .map(f => sectors.find(i => getIdOrNull(i) === f))
    )
  }

  return (
    <div
      className='h-100'
      style={{ display: 'flex', flexDirection: 'column', gap: px(PADDING * (isHostpitalDepartmentViewToggled ? 3 : 1)), height: '100%' }}
    >
      {!isHostpitalDepartmentViewToggled && (
        <div style={{ flex: '0 0 22%', minHeight: px(200), display: 'flex' }}>
          <SearchCheckbox
            style={{ width: '350px' }}
            checkAllOption
            items={sectors}
            values={selectedSectors}
            labelKey='name'
            loading={loading}
            tooltipKey='name'
            title={t('common.sectors')}
            valueKey='id'
            onCheck={onSelectEntity}
            onCheckAll={onSelectEntity}
          />
        </div>
      )}
      {isHostpitalDepartmentViewToggled && (
        <div className='w-100'>
          <h4><b>{t('common.hospital_departments')}</b></h4>
          <div>

            <TreeSelect
              className='w-100'
              value={selected}
              onChange={handleSelect}
              multiple
              treeCheckable
              dropdownStyle={{ maxHeight: px(400), overflowY: 'auto' }}
              dropdownClassName='ant-tree-select-padding'
            >
              {sectorsByHospitalDepartments.map(dept => (
                <TreeSelect.TreeNode
                  value={Prefixes.DEPARTMENT + dept.id}
                  key={Prefixes.DEPARTMENT + dept.id}
                  title={dept.name}
                  checkable={false}
                >
                  {dept.sectors.map(s => (
                    <TreeSelect.TreeNode
                      value={Prefixes.SECTOR + s.id}
                      key={Prefixes.SECTOR + s.id}
                      title={s.name}
                    />
                  ))}
                </TreeSelect.TreeNode>
              ))}
            </TreeSelect>
          </div>
        </div>
      )}
      {isHostpitalDepartmentViewToggled && (
        <div style={{ flex: '1 1 50%', minHeight: px(260), overflow: 'hidden' }}>
          <InstitutionSectionsList selected={selectedSections} onSelect={onSelectSections} />
        </div>
      )}
      {!isHostpitalDepartmentViewToggled && (
        <div className='mt-16 pd-4' style={{ height: calc(pc(70), '-', px(PADDING * 5)) }}>
          <InstitutionSchoolsList selected={schools.map(getIdOrNull)} onSelect={onSelectSchools} />
        </div>
      )}
    </div>
  )
}

export default Settings
